import { render, staticRenderFns } from "./WishlistButtonStore.vue?vue&type=template&id=898b7362&lang=pug&"
import script from "./WishlistButtonStore.vue?vue&type=script&lang=ts&"
export * from "./WishlistButtonStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports